import { FC, useEffect, useRef, useState } from 'react'
import { useLayout } from '../../../_metronic/layout/core'
import SVG from 'react-inlinesvg'
import { Link, useHistory } from 'react-router-dom'
import { fleurSVGBlack } from '../../utils/constants'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

const RequestIntroductionSuccessPage: FC = () => {
    const history = useHistory()
    useEffect(() => {
        document.body.classList.add('body-container-message-introduction');
        document.getElementById('kt_footer')?.classList.add('w-100');
    }, [])

    return (<div className='tap-flex-center'>
        <div aria-hidden='true' className='introductions-image-background'>
            <img
                className='nb-hero__img'
                src={toAbsoluteUrl('/media/login-room.png')}
                alt=''
                loading='eager'
            />
            </div>
        <div className="tap-add-experience-success-container" style={{maxWidth:'833px'}}>
            <div className="tap-add-experience-success-title">
                Thank you. Your introduction request has been successfully received
            </div>
            <div className="tap-add-experience-success-subtitle">
                You can expect a response as soon as possible. You may check the status of your request at any time in your ‘My Introductions’ section. Once the request is approved by our team and the Member, you will be able to communicate directly via messenger to arrange a meeting or discuss your topic of interest.
            </div>
            <div className="tap-add-experience-success-icon-wrapper">
                <div className='line-svg'>
                    <SVG src={'/media/svg/nobilis/teams_and_partner/mask-success-line-icon.svg'} />
                </div>
                <div className='icon-svg'>
                    <SVG src={fleurSVGBlack} />
                </div>
                <div className='line-svg'>
                    <SVG src={'/media/svg/nobilis/teams_and_partner/mask-success-line-icon.svg'} />
                </div>
                {/* <div className="tap-add-experience-success-icon" /> */}
            </div>
            <div className="w-100 tap-flex-center">
                <div className="tap-add-experience-success-btn-secondary cursor-pointer" onClick={()=>history.push('/my-introduction')}>
                    <div>explore more</div>
                </div>
            </div>
        </div>
    </div>)
}

export { RequestIntroductionSuccessPage }